define([
    "../../hereMapsModule",
    "text!../monitorable/stopModal.html"
], function (hereMapsModule, stopModalView) {
    "use strict";

    return hereMapsModule.service("routeStopModalService", [
        "hereMapsService",
        "$compile",
        "$rootScope",
        function (hereMapsService, $compile, $rootScope) {
            var currentBubble = null;

            return {
                openBubble: openBubble,
                clearBubble: clearBubble
            };

            function clearBubble() {
                var ui = hereMapsService.getUi();
                if (ui && currentBubble) {
                    ui.removeBubble(currentBubble);
                    currentBubble = null;
                }
            }

            function openBubble(coordinate, stopData) {
                var Here = hereMapsService.getHere();
                var ui = hereMapsService.getUi();

                if (!ui || !Here) {
                    return;
                }

                clearBubble();

                currentBubble = new Here.ui.InfoBubble(coordinate, {
                    content: createHTMLModal(stopData)
                });
                ui.addBubble(currentBubble);
            }

            function createHTMLModal(stopData) {
                var modalScope = $rootScope.$new(true);
                modalScope.stopInfo = stopData.stopInfo;
                var compiledElement = $compile(stopModalView)(modalScope);
                return compiledElement[0];
            }
        }
    ]);
});